module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us awards",
    attrs: {
      "id": "awards"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('awards.hedingTopText'))
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "more-about-us white",
    attrs: {
      "href": "#top",
      "data-scroll-offset": _vm.scrollOffset,
      "data-aos": "fade-up"
    },
    on: {
      "click": _vm.smoothScroll
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('awards.seeAwards')))])])]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "why-us-solution",
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "elements"
  }, [_c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Uniejów, 06.2025 Lider Inteligentnego Rozwoju")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Leader of Intelligent Development")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                  W czerwcu 2025 roku podczas gali w Uniejowie zostaliśmy uhonorowani nagrodą „Lider Inteligentnego Rozwoju”. To wyróżnienie potwierdza naszą determinację w dążeniu do innowacji oraz rozwój oparty na nowoczesnych technologiach.\n\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                  Bioseco was honored with the “Leader of Intelligent Development” award. This recognition confirms our commitment to innovation and growth driven by cutting-edge technologies.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2024 Polsko–Niemiecka Nagroda Gospodarcza")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish-German Economic Award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n                 Bioseco otrzymało Polsko–Niemiecką Nagrodę Gospodarczą, która podkreśla nasze zasługi w budowaniu partnerskich relacji biznesowych między Polską a Niemcami. To wyróżnienie stanowi dowód na naszą skuteczność i zaangażowanie w rozwój współpracy międzynarodowej.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nBioseco received the Polish-German Economic Award, which highlights our contributions to building strong business partnerships between Poland and Germany. This recognition serves as proof of our effectiveness and commitment to fostering international cooperation.                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2023 Nagroda Pomorska Gryf Gospodarczy")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Pomeranian Economic Griffin Award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nZostaliśmy uhonorowani Nagrodą Pomorski Gryf Gospodarczy, która docenia nasz wkład w rozwój regionalnej gospodarki. To prestiżowe wyróżnienie podkreśla nasze zaangażowanie i sukcesy na Pomorzu.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nWe were honored with the Pomeranian Economic Griffin Award, recognizing our contribution to the development of the regional economy. This prestigious distinction highlights our commitment and achievements in the Pomerania region.                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2022 Orzeł Innowacji „Rzeczpospolitej”")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Eagle of Innovation")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nOtrzymaliśmy prestiżową nagrodę Orzeł Innowacji „Rzeczpospolitej”, która wyróżnia naszą innowacyjność i nowatorskie rozwiązania. To potwierdzenie naszego zaangażowania w rozwój technologiczny i ciągłe poszukiwanie innowacji.                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nBioseco received the prestigious “Rzeczpospolita” Eagle of Innovation Award, which recognizes our innovation and pioneering solutions. This accolade confirms our dedication to technological development and continuous pursuit of innovation.    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2021 Polski Produkt Przyszłości")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Polish Product of the Future")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nzdobyliśmy wyróżnienie Polski Produkt Przyszłości, które podkreśla innowacyjny charakter naszego rozwiązania. To potwierdzenie naszej wizji i zaangażowania w tworzenie nowoczesnych technologii.               ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nWe were awarded the Polish Product of the Future distinction, which highlights the innovative nature of our solution. This recognition confirms our vision and commitment to developing modern technologies.    ")]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(6), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2021 Zielony Orzeł \"Rzeczpospolitej\"")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("“Rzeczpospolita” Green Eagle")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\nOtrzymaliśmy Zielonego Orła „Rzeczpospolitej”, nagrodę za nasze działania na rzecz zrównoważonego rozwoju i ekologii. To wyróżnienie podkreśla nasze zaangażowanie w ochronę środowiska i odpowiedzialność społeczną.              ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("\n\nBioseco received the “Rzeczpospolita” Green Eagle Award for our efforts in sustainable development and environmental protection. This recognition highlights our commitment to environmental stewardship and social responsibility.    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(7), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Genewa-Bruksela, 10.2020.")]), _vm._v("\n                  Bioseco znalazła się w gronie zwycięzców programu Tech Tour Photonics.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Geneva-Brussels, 10.2020.")]), _vm._v("\n                  Bioseco was among the winners of the Tech Tour Photonics program.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(9), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("50 Najbardziej Kreatywnych")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("50 Most Creative People in Business")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 28.09.2020.")]), _vm._v("\n                  II Miejsce wśród 50 Najbardziej Kreatywnych Ludzi w Biznesie dla Krzysztofa Paszka, współzałożyciela\n                  Bioseco. Nagroda zdobyta na dziesiątej Jubileuszowej Gali pod patronatem Ministerstwa Rozwoju, PKN\n                  Orlen SA, Google for Startups, Santander Bank Polska, Krajowa Izba Gospodarcza.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, September 28, 2020.")]), _vm._v("2nd place among the 50 Most Creative People in Business for Krzysztof\n                  Paszek, co-founder of Bioseco. The award was won at the tenth Jubilee Gala under the patronage of the\n                  Polish Ministry of Development, PKN Orlen SA, Google for Startups, Santander Bank Polska, the Polish\n                  Chamber of Commerce.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Miesięcznik „My Company”")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Monthly newspaper \"My Company\"")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 08.2019")]), _vm._v("\n                  Bioseco w gronie dwudziestu firm, które zmienią Polskę według miesięcznika „My Company”.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, 08.2019.")]), _vm._v("\n                  Bioseco among twenty companies that will change Poland according to the monthly newspaper \"My\n                  Company\".\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(11), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bioseco startupem pozytywnego wpływu")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Bioseco - Positive Impact Startup")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warszawa, 04.2019.")]), _vm._v("\n                  Bioseco startupem pozytywnego wpływu. W pierwszej edycji Raportu Startupów Pozytywnego Wpływu 2019\n                  organizowanego przez Kozminski Business Hub wśród innowacyjnych polskich startupów znalazło się\n                  Bioseco.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Warsaw, 04.2019.")]), _vm._v("\n                  Bioseco - Positive Impact Startup. In the first edition of the 2019 Positive\n                  Impact Startup Report organized by Kozminski Business Hub, Bioseco was among the innovative Polish\n                  startups.")]) : _vm._e()])]), _vm._v(" "), _vm._m(12)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(13), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Parlament Europejski. Bruksela, 2019.")]), _vm._v("\n                  Bioseco znalazło się w gronie firm z obszaru innowacyjnych technologii wybranych przez jury IEEE\n                  Entrepreneurship Stars, organizacji pod patronatem Parlamentu Europejskiego.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Brussels, 2019.")]), _vm._v("\n                  2018 IEEE N3XT® STAR. Bioseco is among the companies in the area of ​​innovative\n                  technologies selected by the jury of IEEE Entrepreneurship Stars, an organization under the patronage\n                  of the European Parliament.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(15), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(16), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Bruksela, 29.11.2018.")]), _vm._v("\n                  Wygrana w prestiżowym konkursie EUtop50 dla innowatorów z całej Unii Europejskiej. Dziesiąta edycja\n                  konkursu organizowanego przez Parlament Europejski.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Brussels, 29/11/2018.")]), _vm._v("\n                  Winner of the prestigious EUtop50 Innovators, contest for young companies\n                  from all over the European Union. The tenth edition of the competition organized by the European\n                  Parliament.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_vm._m(18), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, 08.04.2015.")]), _vm._v("\n                  Pomorskie Sztormy, Zwycięzca konkursu w kategorii Młoda Firma Roku 2014. 10 edycja plebiscytu Gazety\n                  Wyborczej i Marszałka Województwa Pomorskiego.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, April 8, 2015.")]), _vm._v("\n                  “Pomorskie Sztormy”, Winner of the competition in the Young Company of the\n                  Year 2014 category. 10th edition of the Gazeta Wyborcza and the Marshal of the Pomeranian Voivodeship.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(19)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_vm._m(20), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Lider PPNT")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Leader of the PPNT")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdynia 12.2014.")]), _vm._v("\n                  Lider Pomorskiego Parku Naukowo-Technologicznego w Gdyni. Nagroda przyznana przez społeczność prawie\n                  trzystu firm z obszaru nowych technologii.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdynia 12.2014.")]), _vm._v("\n                  Leader of the Pomeranian Science and Technology Park in Gdynia. The award was\n                  granted by a community of three hundred innovative companies.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(21)]), _vm._v(" "), _c('div', {
    staticClass: "element clearfix"
  }, [_c('div', [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), (_vm.lang === 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Nagroda Grand Prix Innowacje 2014")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Grand Prix Innovation 2014 award")]) : _vm._e()]), _vm._v(" "), (_vm.lang === 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, 24.10.2014.")]), _vm._v("\n                  Nagroda Grand Prix Innowacje 2014. Technikon, 10 Targi Techniki Przemysłowej Nauki i Innowacji.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lang !== 'pl') ? _c('p', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('em', [_vm._v("Gdańsk, October 24, 2014.")]), _vm._v("\n                  Grand Prix Innovation 2014 award. Technikon, 10th Industrial Technology,\n                  Science and Innovation Fairs.\n                ")]) : _vm._e()])]), _vm._v(" "), _vm._m(22)])])])]), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": "/static/img/awards/Leader_of_Intelligent_Development.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Polish-German_Economic_Award.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "src": "/static/img/awards/Pomeranian_Economic_Griffin_Award.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Eagle_of_Innovation.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Polish_Product_of_the_Future.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/awards/Rzeczpospolita_Green_Eagle.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Tech Tour Photonics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/photonics.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/top50.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/top50.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/pozytywny.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/pozytywny.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("2018 IEEE N3XT® STAR.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/iee_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/eu50_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("EUtop50")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/eu50_resized.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "hexagon",
    attrs: {
      "data-aos": "flip-right",
      "data-aos-delay": "100"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("“Pomorskie Sztormy”")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/sztormy.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/lider-ppnt.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-mobile"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/media/lider-ppnt.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "/static/img/media/grandprix.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e611a2f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Awards.vue
// module id = 312
// module chunks = 0